export const sharedAccountSettings = {
  confirmNewPassword: "Confirm new password",
  confirmPasswordError: "Passwords do not match",
  currentPassword: "Current password",
  editPassword: "Edit password",
  modifyEmailContactCS: "To modify your email address, contact {{practitionerSupportEmail}}",
  newPassword: "New password",
  passwordLengthError: "Must contain at least 8 characters",
  passwordUpdatedSuccess: "Password updated successfully",
  savePassword: "Save password",
  setPassword: "Set password",
  createPassword: "Create your password",
  passwordRequirements: "Your password must be at least 8+ characters long.",
  SetUp: "Set up",
  Manage: "Manage",
  MultiplePlatformWarning:
    "Your account is shared between Fullscript and Emerson Ecologics. Changes will affect both platforms.",
} as const;
